var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":'light-' + _vm.statusColor}},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }